import { createApp as y, h as s, Suspense as c } from "vue";
import { defineComponent as f, ref as p, watch as m, onMounted as l, onUnmounted as d, h as S } from "@histoire/vendors/vue";
import * as e from "virtual:$histoire-setup";
import * as n from "virtual:$histoire-generated-global-setup";
import { registerGlobalComponents as v } from "./global-components.js";
import { RouterLinkStub as h } from "./RouterLinkStub.js";
const C = f({
  name: "MountStory",
  props: {
    story: {
      type: Object,
      required: !0
    }
  },
  setup(o) {
    const r = p();
    let t;
    async function u() {
      t = y({
        name: "MountStorySubApp",
        render: () => s(c, [
          s(o.story.file.component, {
            story: o.story
          })
        ])
      }), v(t), t.component("RouterLink", h), m(() => o.story.variants, () => {
        t._instance.proxy.$forceUpdate();
      }), typeof (n == null ? void 0 : n.setupVue3) == "function" && await n.setupVue3({
        app: t,
        story: o.story,
        variant: null
      }), typeof (e == null ? void 0 : e.setupVue3) == "function" && await e.setupVue3({
        app: t,
        story: o.story,
        variant: null
      });
      const i = document.createElement("div");
      r.value.appendChild(i), t.mount(i);
    }
    function a() {
      t == null || t.unmount();
    }
    return m(() => o.story.id, async () => {
      a(), await u();
    }), l(async () => {
      await u();
    }), d(() => {
      a();
    }), {
      el: r
    };
  },
  render() {
    return S("div", {
      ref: "el"
    });
  }
});
export {
  C as default
};
